import { v4 as uuid } from 'uuid';
import { IOptionItem, ITopPlayerItem } from './interfaces';

export const TOP_WIN_OPTIONS: IOptionItem[] = [
  { name: 'Last 24 hours', value: 'last24hours' },
  { name: 'Last 7 days', value: 'last7days' },
  { name: 'Last 30 days', value: 'last30days' },
];

export const TOP_PLAYERS_OPTIONS: IOptionItem[] = [
  { name: 'All Games', value: 'all' },
  { name: 'Blackjack', value: 'blackjack' },
  { name: 'Coinflip', value: 'coinflip' },
  { name: 'Jackpot', value: 'jackpot' },
];

const user = {
  avatar_url: 'https://placekitten.com/150',
  username: 'Username01',
  id: uuid(),
};

export const TOP_WIN_PLAYER: ITopPlayerItem = {
  user,
  earnings: 145_332,
};

export const TOP_PLAYERS_PLAYER: ITopPlayerItem = {
  user,
  experience: 1_400_000,
  level: 'Dueler V',
};
